import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { cloneDeep } from 'lodash';
import router from '../router';


const api = axios.create({
  baseURL: (process.env.NODE_ENV === 'development') ? 'https://tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`,
  headers: {
    'Content-Type': 'application/hal+json',
    Accept: 'application/json',
  },
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isErrorLink: false,
    category: '',
    /* eslint-disable import/no-unresolved */
    /* eslint-disable global-require */
    userInfo: {
      objectName: '',
      objectAdress: '',
      userName: '',
      userMail: '',
      userPhone: '',
      userCompany: '',
      link: '',
    },
    rowsToPdf: [],
    result: [],
    materialsTypes: [],
    materials: [],
    specialMaterials: [],
    slopes: [
      {
        name: 'Участок 1',
        material: '',
        materialSize: {
          width: 0,
          height: 0,
        },
        fixtureCalculation: {
          need: true,
          type: 'concrete',
          thickness: 0,
          base: 'default',
          material: {
            id: 0,
            name: 'ТехноРуф Н КЛИН 1',
            angle: 1.7,
            src: require('@/assets/img/materials/1.jpg'),
            link: 'https://www.google.com/search?newwindow=1&source=hp&ei=CPt1Xfv8Ja6wrgTvu6j4CA&q=ТехноРуф+Н+КЛИН+1',
            plateAVal: '30-50',
            plateBVal: '50-70',
            plateCVal: '40',
            type: 'Каменная вата',
            params: [
              {
                id: 0,
                width: 1200,
                height: 600,
              },
              {
                id: 1,
                width: 1200,
                height: 1200,
              },
            ],
          },
        },
        slopeCount: 1,
        slopeLayersCount: 1,
        slopeType: '',
        slopeForm: 'square',
        slopeParams: [
          {
            width: 4,
            height: 4,
          },
        ],
      },
    ],
    slopeForms: {
      square: {
        width: 4,
        height: 4,
      },
      trapezoid: {
        width: 6,
        height: 4,
        bias1: 0.5,
        bias2: 0.5,
      },
      reverseTrapezoid: {
        width: 6,
        height: 4,
        bias1: 0.5,
        bias2: 0.5,
      },
      cornerLeftTop: {
        width: 2,
        height: 1,
        biasHeight: 1,
        biasWidth: 1,
      },
      cornerRightTop: {
        width: 2,
        height: 2,
        biasHeight: 1,
        biasWidth: 1,
      },
      cornerLeftBottom: {
        width: 2,
        height: 1,
        biasHeight: 1,
        biasWidth: 1,
      },
      cornerRightBottom: {
        width: 2,
        height: 2,
        biasHeight: 1,
        biasWidth: 1,
      },
      triangle: {
        width: 3,
        ratio: 3,
        roofSlope: 1.7,
      },
      doubleSideTriangleHorizontal: {
        width: 3,
        ratio: 3,
        roofSlope: 1.7,
      },
      doubleSideTriangleVertical: {
        width: 3,
        ratio: 3,
        roofSlope: 1.7,
      },
      rhombus: {
        width: 3,
        ratio: 3,
        roofSlope: 1.7,
      },
      rectangularTrapezoidVertical: {
        width: 3,
        ratio: 3,
        bias1: 0.5,
        roofSlope: 1.7,
      },
      rectangularTrapezoidHorizontal: {
        width: 3,
        ratio: 3,
        bias1: 0.5,
        roofSlope: 1.7,
      },
      doubleSideRectangularTrapezoidVertical: {
        width: 3,
        ratio: 3,
        bias1: 0.5,
        roofSlope: 1.7,
      },
    },
    defaultFixtureCalculation: {
      need: true,
      type: 'concrete',
      thickness: 0,
      base: 'default',
      material: {
        id: 0,
        name: 'ТехноРуф Н КЛИН 1',
        angle: 1.7,
        src: require('@/assets/img/materials/1.jpg'),
        link: 'https://www.google.com/search?newwindow=1&source=hp&ei=CPt1Xfv8Ja6wrgTvu6j4CA&q=ТехноРуф+Н+КЛИН+1',
        plateAVal: '30-50',
        plateBVal: '50-70',
        plateCVal: '40',
        type: 'Каменная вата',
        params: [
          {
            id: 0,
            width: 1200,
            height: 600,
          },
          {
            id: 1,
            width: 1200,
            height: 1200,
          },
        ],
      },
    },
    defaultSlope: {
      name: 'Участок 1',
      material: '',
      materialSize: {
        width: 0,
        height: 0,
      },
      fixtureCalculation: {
        need: true,
        type: 'concrete',
        thickness: 0,
        base: 'default',
        material: {
          id: 0,
          name: 'ТехноРуф Н КЛИН 1',
          angle: 1.7,
          src: require('@/assets/img/materials/1.jpg'),
          link: 'https://www.google.com/search?newwindow=1&source=hp&ei=CPt1Xfv8Ja6wrgTvu6j4CA&q=ТехноРуф+Н+КЛИН+1',
          plateAVal: '30-50',
          plateBVal: '50-70',
          plateCVal: '40',
          type: 'Каменная вата',
          params: [
            {
              id: 0,
              width: 1200,
              height: 600,
            },
            {
              id: 1,
              width: 1200,
              height: 1200,
            },
          ],
        },
      },
      slopeCount: 1,
      slopeLayersCount: 1,
      slopeType: '',
      slopeForm: 'square',
      slopeParams: [
        {
          width: 4,
          height: 4,
        },
      ],
    },
    /* eslint-disable import/no-unresolved */
    /* eslint-disable global-require */
    defaultSvgParams: {
      width: 680,
      height: 480,
      baseHeight: 4,
      baseWidth: 6,
      baseBiasW: 2,
      ratio: 3,
      navScale: 0.1765,
    },
  },
  getters: {
    // allPosts(state) {
    //   return state.posts;
    // },
    // isErrorLink(state) {
    //   return state.isErrorLink;
    // },
    allSlopes(state) {
      return state.slopes;
    },
    getSlope: (state) => (id) => {
      return state.slopes[id];
    },
    getDafaultSvgParams(state) {
      return state.defaultSvgParams;
    },
    allMaterials(state) {
      return state.materials;
    },
    allMaterialsTypes(state) {
      return state.materialsTypes;
    },
    getMaterial: (state) => (id) =>{
      return state.materials.findIndex(p => p.id === id);
    },
    getResult(state) {
      return state.result;
    },
    getRowsToPdf(state) {
      return state.rowsToPdf;
    },
  },
  mutations: {
    updateSlopeType: (state, payload) => {
      state.slopes[payload.id].slopeType = payload.type;
      if (payload.type === 'mainSlope') {
        Vue.set(state.slopes[payload.id], 'slopeParams', cloneDeep([state.slopeForms['square']]));
        delete state.slopes[payload.id].fixtureCalculation.base;
        delete state.slopes[payload.id].fixtureCalculation.material;
      } else {
        Vue.set(state.slopes[payload.id], 'slopeParams', cloneDeep([state.slopeForms['triangle']]));
        state.slopes[payload.id].slopeForm = 'triangle';
      }
    },
    updateSlopeForm: (state, payload) => {
      state.slopes[payload.id].slopeForm = payload.form;
      Vue.set(state.slopes[payload.id], 'slopeParams', cloneDeep([state.slopeForms[payload.form]]));
      state.slopes[payload.id].slopeCount = 1;
      state.slopes[payload.id].slopeLayersCount = 1;
    },
    updateSlopeWidth: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].width = payload.width;
    },
    updateSlopeHeight: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].height = payload.height;
    },
    updateSlopeBias1: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].bias1 = payload.bias1;
    },
    updateSlopeBias2: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].bias2 = payload.bias2;
    },
    updateSlopeBiasHeight: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].biasHeight = payload.biasHeight;
    },
    updateSlopeBiasWidth: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].biasWidth = payload.biasWidth;
    },
    updateSlopeRatio: (state, payload) => {
      state.slopes[payload.id].slopeParams.ratio = payload.ratio;
    },
    updateSlopeRatioNew: (state, payload) => {
      state.slopes[payload.id].slopeParams[0].ratio = payload.ratio;
    },
    updateSlopeCount: (state, payload) => {
      state.slopes[payload.id].slopeCount = payload.count;
    },
    updateSlopeLayersCount: (state, payload) => {
      state.slopes[payload.id].slopeLayersCount = payload.count;
    },
    updateFixtureCalculation: (state, payload) => {
      if (payload.need === false) {
        state.slopes[payload.id].fixtureCalculation.need = payload.need;
        delete state.slopes[payload.id].fixtureCalculation.type;
        delete state.slopes[payload.id].fixtureCalculation.thickness;
        delete state.slopes[payload.id].fixtureCalculation.base;
        delete state.slopes[payload.id].fixtureCalculation.material;
      } else {
        if (payload.slopeType === 'contrSlope') {
          Vue.set(state.slopes[payload.id], 'fixtureCalculation', cloneDeep(state.defaultFixtureCalculation));
        } else {
          Vue.set(state.slopes[payload.id], 'fixtureCalculation', cloneDeep(state.defaultFixtureCalculation));
          delete state.slopes[payload.id].fixtureCalculation.base;
          delete state.slopes[payload.id].fixtureCalculation.material;
        }
      }
    },
    updateFixtureCalculationType: (state, payload) => {
      state.slopes[payload.id].fixtureCalculation.type = payload.type;
    },
    updateFixtureCalculationThickness: (state, payload) => {
      state.slopes[payload.id].fixtureCalculation.thickness = payload.val;
    },
    updateFixtureCalculationBase: (state, payload) => {
      state.slopes[payload.id].fixtureCalculation.base = payload.val;
    },
    updateFixtureCalculationMaterial: (state, payload) => {
      state.slopes[payload.id].fixtureCalculation.material = payload.material;
    },
    updateRoofSlope: (state, payload) => {
      state.slopes[payload.id].slopeParams.roofSlope = payload.val;
    },
    updateSlopeMaterial: (state, payload) => {
      // state.slopes[payload.id].material = payload.material;
      Vue.set(state.slopes[payload.id], 'material', cloneDeep(payload.material));
    },
    updateSlopeMaterialSizes: (state, payload) => {
      // state.slopes[payload.id].materialSize.width = payload.sizes.width;
      // state.slopes[payload.id].materialSize.height = payload.sizes.height;
      Vue.set(state.slopes[payload.id].materialSize, 'width', cloneDeep(payload.sizes.width));
      Vue.set(state.slopes[payload.id].materialSize, 'height', cloneDeep(payload.sizes.height));
      Vue.set(state.slopes[payload.id].materialSize, 'id', cloneDeep(payload.sizes.id));
    },
    updateSlopeName: (state, payload) => {
      state.slopes[payload.id].name = payload.name;
    },
    addNewSlope: (state, payload) => {
      state.defaultSlope.name = `Участок ${payload.id}`;
      state.slopes.push(cloneDeep(state.defaultSlope));
    },
    replaceAllSlopes(state, payload) {
      state.slopes = payload;
    },
    updateMaterials(state, payload) {
      // state.materials = payload;
      Vue.set(state, 'materials', cloneDeep(payload));
      const specialMaterials = payload.filter((material) => {
        return material.angle === 1.7;
      });
      Vue.set(state, 'specialMaterials', cloneDeep(specialMaterials));
    },
    updateMaterialsTypes(state, payload) {
      state.materialsTypes = payload;
    },
    updateResult(state, payload) {
      state.result = payload;
    },
    deleteSlope(state, payload) {
      state.slopes.splice(payload, 1);
    },
    removeSlopeMaterial(state, payload) {
      // state.slopes[payload].material = '';
      // state.slopes[payload].materialSize.width = '';
      // state.slopes[payload].materialSize.height = '';
      Vue.set(state.slopes[payload], 'material', cloneDeep(state.defaultSlope.material));
      Vue.set(state.slopes[payload].materialSize, 'width', cloneDeep(state.defaultSlope.materialSize.width));
      Vue.set(state.slopes[payload].materialSize, 'height', cloneDeep(state.defaultSlope.materialSize.height));
    },
    setSlopeToDefault(state, payload) {
      Vue.set(state.slopes[payload], 'slopeType', cloneDeep(''));
      Vue.set(state.slopes[payload], 'material', cloneDeep(''));
      Vue.set(state.slopes[payload], 'slopeForm', cloneDeep('square'));
      Vue.set(state.slopes[payload].materialSize, 'width', cloneDeep(0));
      Vue.set(state.slopes[payload].materialSize, 'height', cloneDeep(0));
      Vue.set(state.slopes[payload], 'fixtureCalculation', cloneDeep(state.defaultSlope.fixtureCalculation));
      Vue.set(state.slopes[payload], 'slopeParams', cloneDeep(state.defaultSlope.slopeParams));
    },
    updateRowsToPdf(state, payload) {
      Vue.set(state, 'rowsToPdf', cloneDeep(payload));
    },
    updateUserInfoParam(state, payload) {
      state.userInfo[payload.param] = payload.val;
    },
    RESET_SLOPES(state) {
      state.slopes = [];
      state.userInfo.objectName = '';
      state.userInfo.objectAdress = '';
      state.userInfo.userName = '';
      state.userInfo.userMail = '';
      state.userInfo.userPhone = '';
      state.userInfo.userCompany = '';
      state.userInfo.link = '';
    },
    UPDATE_CATEGORY(state, payload) {
      state.category = payload;
    },
    FILTER_MATERIALS_BY_CATEGORY(state, payload) {
      const filter = state.materialsTypes[state.materialsTypes.findIndex(p => p.id
        === payload)].name;
      const filteredMaterials = state.materials.filter(material => material.type === filter);
      console.log(filteredMaterials);
      state.materials = [];
      // state.materials = filteredMaterials;
      Vue.set(state, 'materials', cloneDeep(filteredMaterials));
      const specialMaterials = filteredMaterials.filter((material) => {
        return material.angle === 1.7;
      });
      state.specialMaterials = [];
      Vue.set(state, 'specialMaterials', cloneDeep(specialMaterials));
      Vue.set(this.state.defaultSlope.fixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
      Vue.set(this.state.defaultFixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
    },
    FILTER_CATEGORIES_BY_CATEGORY(state, payload) {
      const filteredCategories = state.materialsTypes.filter(category => category.id === payload);
      state.materialsTypes = [];
      // state.materialsTypes = filteredCategories;
      Vue.set(state, 'materialsTypes', cloneDeep(filteredCategories));
    },
  },
  actions: {
    async fetchMaterials(ctx) {
      // const res = await fetch('http://tn-calc.industrialmedia.com.ua/action/service_api/get_products');
      // const materials = await res.json();
      await api.get('service_api/get_products')
        .then((response) => {
          // this.$store.commit('updateMaterials', response.data);
          ctx.commit('updateMaterials', response.data);
          Vue.set(this.state.defaultSlope.fixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
          Vue.set(this.state.defaultFixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
        });
      await api.get('service_api/get_category')
        .then((materialsTypes) => {
          ctx.commit('updateMaterialsTypes', materialsTypes.data);
        });
    },
    async materialsPostProcessing(commit) {
      // await dispatch('fetchMaterials');
      if (this.state.category !== '') {
        await commit('FILTER_CATEGORIES_BY_CATEGORY', this.state.category);
        await commit('FILTER_MATERIALS_BY_CATEGORY', this.state.category);
      }
    },
    async fetchMaterialsMain(ctx, payload) {
      // const res = await fetch('http://tn-calc.industrialmedia.com.ua/action/service_api/get_products');
      // const materials = await res.json();
      // console.log(payload);
      await api.get('service_api/get_products', {
        params: {
          category: payload,
        },
      })
        .then((response) => {
          // this.$store.commit('updateMaterials', response.data);
          ctx.commit('updateMaterials', response.data);
          if (typeof (payload) !== 'undefined') {
            ctx.commit('UPDATE_CATEGORY', payload);
          }
          api.get('service_api/get_category', {
            params: {
              category: payload,
            },
          })
            .then((materialsTypes) => {
              ctx.commit('updateMaterialsTypes', materialsTypes.data);
              Vue.set(this.state.slopes[0].fixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
              Vue.set(this.state.defaultSlope.fixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
              Vue.set(this.state.defaultFixtureCalculation, 'material', cloneDeep(this.state.specialMaterials[0]));
            });
        })
        .catch((error) => {
          // handle error
          ctx.commit('UPDATE_CATEGORY', '');
          router.push('/404');
        });
    },
    async fetchMaterialsTypes(ctx) {
      await api.get('service_api/get_category')
        .then((response) => {
          ctx.commit('updateMaterialsTypes', response.data);
        });
    },
  },
});
